const {KitModule, registerModule} = window;
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class Hero extends KitModule {
  constructor($element) {
    super($element);
    this.init();
  }

  init() {
    this.setVars();
    this.checkScreenSize();
    this.bindMediaQuery();
    this.animation();
  }

  onViewportResize() {
    this.checkScreenSize();
  }

  setVars() {
    this.navHeight = document.querySelector('.nav').offsetHeight;
    this.nextSibling = this.$element.nextSibling.nextElementSibling;
    this.elbgColor = this.$element.dataset.color;
    this.bgColor = this.elbgColor == 'dark' ? '#17181B' : '#FFF';
    this.colHeight = this.$masonry.offsetHeight;
    this.$frames = this.$element.querySelectorAll(
      '.home-masonry__column .frame',
    );
    this.hasSmallWindowHeight = window.innerHeight < this.$element.offsetHeight;
    this.titleSpeed = this.isDesktop ? 2 : 2.8;
    this.titleOffset =
      this.colHeight -
      this.navHeight -
      (this.isWide ? 100 : 20) +
      this.$title.offsetHeight * this.titleSpeed;

    this.tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.hero',
        endTrigger: this.nextSibling, // end trigger when bottom hit the next section
        start: `top ${this.navHeight}px`,
        end: `bottom ${this.navHeight}px`,
        scrub: 1,
        // pin: '.hero',
        // onToggle: (self) => (self.spacer.style.backgroundColor = this.bgColor),
      },
    });
  }

  checkScreenSize() {
    if (
      this.hasSmallWindowHeight &&
      !this.$element.classList.contains('hero--tall')
    ) {
      this.$element.classList.add('hero--tall');
    }
  }

  animation() {
    this.tl
      .to(this.$frames, {
        y: (i) =>
          (this.$frames[i].parentElement.clientHeight - this.navHeight - 20) *
          -1,
        ease: 'none',
        duration: 2,
        stagger: (index, target, allFrames) => {
          index;
          const speeds = [];
          const columns = [...this.$grid.children];
          const framesSortedByColumn = [];
          allFrames.forEach((frame) => {
            columns.forEach((column, columnIndex) => {
              speeds.push(Number(column.dataset.speed));
              if (frame.parentElement === column) {
                if (framesSortedByColumn[columnIndex]) {
                  framesSortedByColumn[columnIndex].push(frame);
                } else {
                  framesSortedByColumn[columnIndex] = [];
                  framesSortedByColumn[columnIndex].push(frame);
                }
              }
            });
          });

          const frameColumnIndex = framesSortedByColumn
            .map((column, columnIndex) => {
              if (column.includes(target)) {
                return columnIndex;
              } else return null;
            })
            .find((val) => val !== null);
          return (
            Math.abs(frameColumnIndex - Math.floor(columns.length / 2)) * 0.02
          );
        },
      })
      .to(
        this.$title,
        {
          y: `-${this.titleOffset}px`,
          duration: 2,
          ease: 'none',
          delay: 0,
        },
        '<',
      )
      .to(this.$column, {
        marginTop: 0,
        ease: 'none',
      });
  }

  bindMediaQuery() {
    // get media query from custom property
    const rootStyle = getComputedStyle(document.documentElement);

    // max nav - mobile
    const maxQuery = rootStyle.getPropertyValue('--max-nav-media-query');
    this.maxMediaQuery = window.matchMedia(maxQuery);

    // listen and set initial
    this.maxMediaQuery.addEventListener(
      'change',
      this.onMaxMediaChange.bind(this),
    );
    this.onMaxMediaChange(this.maxMediaQuery);

    // min wide
    const minWideQuery = rootStyle.getPropertyValue('--min-wide-media-query');
    this.minWideMediaQuery = window.matchMedia(minWideQuery);

    this.minWideMediaQuery.addEventListener(
      'change',
      this.onMinWideMediaChange.bind(this),
    );
    this.onMinWideMediaChange(this.minWideMediaQuery);

    // min nav - desktop
    const minQuery = rootStyle.getPropertyValue('--min-nav-media-query');
    this.minMediaQuery = window.matchMedia(minQuery);
    // listen and set initial
    this.minMediaQuery.addEventListener(
      'change',
      this.onMinMediaChange.bind(this),
    );
    this.onMinMediaChange(this.minMediaQuery);
  }

  onMaxMediaChange(mobileMediaQuery) {
    this.isMobile = mobileMediaQuery.matches;
  }

  onMinWideMediaChange(wideMediaQuery) {
    this.isWide = wideMediaQuery.matches;
  }

  onMinMediaChange(desktopMediaQuery) {
    this.isDesktop = desktopMediaQuery.matches;
  }
}

registerModule('Hero', Hero);
